import { createRouter, createWebHistory } from "vue-router";

const BookType = () => import("../components/catalog/giftBuilder/BookType.vue");
const PaperType = () =>
  import("../components/catalog/giftBuilder/PaperType.vue");
const CoverType = () =>
  import("../components/catalog/giftBuilder/CoverType.vue");
const SizeType = () => import("../components/catalog/giftBuilder/SizeType.vue");
const FormatType = () =>
  import("../components/catalog/giftBuilder/FormatType.vue");
const DesignStep = () =>
  import("../components/catalog/giftBuilder/DesignStep.vue");

const routes = [
  {
    path: "/",
    redirect: "/book-type"
  },
  {
    path: "/book-type",
    component: BookType,
    name: "Book Type",
    meta: { number: 1 }
  },
  {
    path: "/page-type",
    component: PaperType,
    name: "Paper Type",
    meta: { number: 2 }
  },
  {
    path: "/cover-type",
    component: CoverType,
    name: "Cover Type",
    meta: { number: 3 }
  },
  {
    path: "/size-type",
    component: SizeType,
    name: "Size Type",
    meta: { number: 4 }
  },
  {
    path: "/format-type",
    component: FormatType,
    name: "Format Type",
    meta: { number: 5 }
  },
  {
    path: "/choose-design",
    component: DesignStep,
    name: "Design Type",
    meta: { number: 6 }
  }
];

const router = createRouter({
  routes,
  history: createWebHistory(`${window.countryCode}/book-builder`),
  scrollBehavior() {
    return { left: 0, top: 0 };
  }
});

export default router;
